import React from 'react';
import { Modal } from '@/pages/common';
import { Button } from 'gatorcomponents';
import * as Styles from './PixRecAlertModal.styles';

const PixRecAlertModal = ({
  onClosePixRecAlertModal,
  onConfirmPixRecAlertModal,
  isAfterPixRecLimit,
  getDueDateFormated,
  pixRecAlertModalText,
}) => (
  <Modal
    borderRadius={8}
    variant="regular"
    onClose={onClosePixRecAlertModal}
  >
    <Styles.ModalPixRecAlertTitle>
      {pixRecAlertModalText.title}
    </Styles.ModalPixRecAlertTitle>
    <Styles.ModalPixRecAlertDescription>
      {isAfterPixRecLimit() ? pixRecAlertModalText.description.dueDate(getDueDateFormated()) : pixRecAlertModalText.description}
    </Styles.ModalPixRecAlertDescription>
    <Styles.ModalPixRecAlertButtonContainer>
      <Button
        label={pixRecAlertModalText.buttonLabel}
        onClick={onConfirmPixRecAlertModal}
        size="xlarge"
      />
    </Styles.ModalPixRecAlertButtonContainer>
  </Modal>
);
export default PixRecAlertModal;
